// src/lib/cache/employees.js
//
// Per-entity cache wiring for employees. Uses useRefetchListMutation for
// create because the server has a slot-limit trigger that can reject inserts
// in ways the client can't model — refetch after success picks up the real
// row. Update/delete are optimistic.

import {
  getEmployees,
  createEmployee,
  updateEmployee,
  deleteEmployee,
} from '../api/team/employees.js'
import {
  useEntityListQuery,
  useOptimisticListMutation,
  useRefetchListMutation,
  useStandardDeleteMutation,
  defaultUpdateReconcile,
  unwrapList,
} from './entityCache.js'

const ENTITY = 'employees'

export const useEmployeesQuery = () =>
  useEntityListQuery(ENTITY, unwrapList('employees', getEmployees))

// Create skips the optimistic placeholder — the slot-limit trigger can reject
// inserts the client can't predict (paid-plan seat caps).
export const useCreateEmployeeMutation = () =>
  useRefetchListMutation(ENTITY, {
    mutationFn: (employeeData) => createEmployee(employeeData),
  })

export const useUpdateEmployeeMutation = () =>
  useOptimisticListMutation(ENTITY, {
    mutationFn: ({ id, ...patch }) => updateEmployee(id, patch),
    applyOptimistic: (prev, vars) =>
      prev.map((row) => (row.id === vars.id ? { ...row, ...vars } : row)),
    reconcile: defaultUpdateReconcile,
  })

export const useDeleteEmployeeMutation = () =>
  useStandardDeleteMutation(ENTITY, deleteEmployee)
